export const DELETE = "supprimer"


// WEBPACK FOOTER //
// ./src/constant/misc.ts